import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post('/authorize/', data);
};

const getAll = async () => {
  return await httpClient.get('/authorize/');
};

const getFilteredByRegister = async () => {
  return await httpClient.get('/authorize/?filter[tipo]=REGISTRO');
};

export { post, getAll, getFilteredByRegister };
